<template>
  <div v-show="open" class="fddform-load-all">
    <div ref="progress" class="fddform-load-bg"></div>
  </div>
</template>

<script>
  export default {
    name: 'FddLoading',
    data() {
      return {
        step: 2,
        timer: null,
        open: false
      }
    },
    methods: {
      run(speed, time) {
        this.clear()
        this.open = true
        this.timer = setInterval(() => {
          if (this.step < 100) {
            this.step += speed
            this.$refs.progress.style.width = this.step + '%'
          } else {
            this.open = false
            this.clear()
          }
        }, time)
      },
      clear() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
          this.step = 0
        }
      }
    }
  }
</script>

<style scoped>
  .fddform-load-all {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    z-index: 20000;
  }
  .fddform-load-all .fddform-load-bg {
    height: 2px;
    left: 0;
    top: 0;
    background: #4298f9;
    width: 5%;
  }
</style>
